<template>
  <div id="eventsList">
    <div v-if="eventsList">
      <div cols="12" v-for="(event, index) in eventsList.list" :key="index">
        <div>
          <strong>{{ event.eventTypeDisplayName }}</strong>
        </div>

        <span> {{ event.description }}</span>
        <hr />
      </div>
      <div
        class="text-center mt-2 mx-2"
        v-if="eventsList.list && eventsList.list.length"
      >
        <v-row>
          <v-col cols="12" sm="4" md="2">
            <v-select
              outlined
              dense
              v-model="itemsPerPage"
              :items="[5, 10, 20]"
              label="تعداد نمایش در صفحه"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="8" md="10">
            <v-pagination
              circle
              v-model="pageNumber"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
    
    <script>
export default {
  props: {
    eventsList: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pageNumber: 1,
      itemsPerPage: 10,
      eventsList: null,
    };
  },
  created() {
    this.$emit('getSupplierProductEvents', this.pageNumber, this.itemsPerPage);
  },
  computed: {
    pageCount() {
      return Math.ceil(this.eventsList.totalCount / this.itemsPerPage);
    },
  },
  watch: {
    pageNumber(after, before) {
      this.$emit('getSupplierProductEvents', after, this.itemsPerPage);
      this.scrollTopEventsList();
    },
    itemsPerPage(after, before) {
      this.$emit('getSupplierProductEvents', 1, after);
      this.scrollTopEventsList();
    },
  },
  mounted() {
    this.$emit('getSupplierProductEvents', this.pageNumber, this.itemsPerPage);
  },
  methods: {
    scrollTopEventsList() {
      document.getElementById('eventsList').scrollIntoView();
    },
  },
};
</script>
    
    <style lang="scss" scoped>
</style>
    